/**
 * Created by alvinoktavianus on 7/20/17.
 */
/* global mixpanel */

export function libraryGratuityStart ({currOutlet}) {
  mixpanel.track('Library Gratuity Start', {
    'Current Selected Outlet': currOutlet
  })
}

export function libraryGratuityChangeOutlet ({currOutlet}) {
  mixpanel.track('Library Gratuity Change Outlet', {
    'Current Selected Outlet': currOutlet
  })
}

export function libraryGratuityCreate ({values, isAllOutlet}) {
  const eventName = isAllOutlet ? 'Library Gratuity Create All Outlet' : 'Library Gratuity Create One Outlet'
  mixpanel.track(eventName, {
    'Name': values.name,
    'Value': values.amount
  })
}

export function libraryGratuityDelete ({gratuity}) {
  mixpanel.track('Library Gratuity Delete', {
    'Name': gratuity.name,
    'Value': gratuity.amount
  })
}

export function libraryGratuityUpdate ({newValue}) {
  mixpanel.track('Library Gratuity Update One Outlet', {
    'New Name': newValue.name,
    'New Value': newValue.amount
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/library/gratuity.js